import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Junta classes resolvendo conflitos do Tailwind — `p-2 p-4` vira `p-4`. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
